const CONSOLTO_WIDGET_ID = '67a7024d4ab2001a985d82ef';
const CONSOLTO_TRIGGERS = ['mouseover', 'click', 'scroll', 'touchstart', 'keydown'];

// The Consolto app script only renders the widget from an #et-iframe tag, loaded on first interaction like live.
const loadConsolto = () => {
  for (const type of CONSOLTO_TRIGGERS) document.removeEventListener(type, loadConsolto);
  if (document.getElementById('et-iframe')) return;

  // The app's own script-tag run sets this flag even when it fails, which would block this load.
  window.consolto = false;
  const script = document.createElement('script');
  script.id = 'et-iframe';
  script.src = 'https://client.consolto.com/iframeApp/iframeApp.js';
  script.async = true;
  script.dataset.widgetid = CONSOLTO_WIDGET_ID;
  script.dataset.version = '0.5';
  script.dataset.test = 'false';
  document.body.append(script);
};

for (const type of CONSOLTO_TRIGGERS) {
  document.addEventListener(type, loadConsolto, { passive: true });
}
